import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
} from "@ionic/react";
import PaystackPop from "@paystack/inline-js";
import { showLoading, fetchBillingDetails, fetchUser, mpesaStk, initializePaystackTransaction, updateBillingPlan, cancelCardSubscription } from "../../redux/actions";
import { colorTheme, UNIFORM_RESOURCE_LOCATORS } from "../../utils/constants";
import MpesaPayment from "../StepwisePricing/components/MpesaPayment";
import CreditCardPayment from "../StepwisePricing/components/CreditCardPayment";
import PaybillPayment from "../StepwisePricing/components/PaybillPayment";
import SubscriptionPlans from "../StepwisePricing/components/SubscriptionPlans";

const PAYMENT_METHODS = {
  MPESA: 'Get MPESA Prompt',
  CREDIT_CARD: 'Credit Card',
  PAYBILL: 'Paybill'
};

const SUBSCRIPTION_PERIODS = {
  ANNUAL: 'annual',
  QUARTERLY: 'quarterly',
  MONTHLY: 'monthly'
};

const mapDispatchToProps = {
  fetchBillingDetails,
  showLoading,
  fetchUser,
  mpesaStk,
  initializePaystackTransaction,
  updateBillingPlan,
  cancelCardSubscription,
};

const mapStateToProps = (state) => {
  return {
    billing: state.billing,
    user: state.user,
    paystack: state.paystack,
  };
};

class SubscriptionExpired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      paymentMethod: PAYMENT_METHODS.MPESA,
      phoneNumber: "",
      phoneNumberFormatted: "",
      subscriptionPeriod: SUBSCRIPTION_PERIODS.ANNUAL,
      errors: {
        phoneNumber: "",
      },
    };
  }

  async componentDidMount() {
    await this.props.fetchBillingDetails();
    await this.props.fetchUser();
    if (this.props.user?.phoneNumber) {
      this.setState({ phoneNumber: this.props.user.phoneNumber });
    }
    if (this.props.billing?.customerAccount?.paymentSchedule) {
      this.setState({
        subscriptionPeriod: this.props.billing.customerAccount.paymentSchedule
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.paystack?.accessCode !== this.props.paystack?.accessCode && this.props.paystack?.accessCode) {
      const paystackPopup = new PaystackPop();
      paystackPopup.resumeTransaction(this.props.paystack.accessCode);
    }
  }

  handleIHavePaid = async () => {
    this.props.showLoading(true);
    try {
      await this.props.fetchBillingDetails();
      const subscriptionBalance = parseInt(this.props.billing?.customerAccount?.subscriptionBalance) || 0;
      if (subscriptionBalance <= 0) {
        this.props.history.push(UNIFORM_RESOURCE_LOCATORS.dashboard);
      } else {
        alert("Your payment is still being processed. Please wait a few minutes and try again.");
      }
    } catch (error) {
      console.error(error);
      alert("Failed to verify payment status. Please try again.");
    } finally {
      this.props.showLoading(false);
    }
  };

  handleStkPush = (inputPhoneNumber) => {
    const subscriptionBalance = parseInt(this.props.billing?.customerAccount?.subscriptionBalance) || 0;
    if (subscriptionBalance <= 0) {
      alert("No subscription balance to pay.");
      return;
    }
    const finalPhoneNumber = this.state.phoneNumberFormatted || inputPhoneNumber;
    this.props.showLoading(true);
    this.props.mpesaStk({
      phoneNumber: finalPhoneNumber,
      amount: subscriptionBalance,
      paymentItem: "SUB"
    })
    .catch(console.error)
    .finally(() => this.props.showLoading(false));
  };

  handleCreditCardPayment = () => {
    const subscriptionBalance = parseInt(this.props.billing?.customerAccount?.subscriptionBalance) || 0;
    if (subscriptionBalance <= 0) {
      alert("No subscription balance to pay.");
      return;
    }
    this.props.showLoading(true);
    this.props.initializePaystackTransaction({
      amount: subscriptionBalance,
      paymentItem: "subscription"
    })
    .catch(console.error)
    .finally(() => this.props.showLoading(false));
  };

  handleCancelSubscription = () => {
    this.props.showLoading(true);
    this.props.cancelCardSubscription()
      .catch(console.error)
      .finally(() => this.props.showLoading(false));
  };

  handleSubscriptionPeriodChange = async (newPeriod) => {
    const oldSchedule = this.props.billing?.customerAccount?.paymentSchedule;
    if (oldSchedule === newPeriod) {
      this.setState({ subscriptionPeriod: newPeriod });
      return;
    }

    this.props.showLoading(true);
    try {
      await this.props.updateBillingPlan({ newSchedule: newPeriod });
      this.setState({ subscriptionPeriod: newPeriod });
    } catch (error) {
      console.error(error);
      alert("Failed to update subscription period. Please try again.");
    } finally {
      this.props.showLoading(false);
    }
  };

  nextStep = () => {
    this.setState(prevState => ({ currentStep: prevState.currentStep + 1 }));
  };

  prevStep = () => {
    this.setState(prevState => ({ currentStep: prevState.currentStep - 1 }));
  };

  render() {
    const subscriptionBalance = this.props.billing?.customerAccount?.subscriptionBalance || 0;
    const paybillDetails = {
      paybill: this.props.billing?.constants?.bomahut_mpesa_paybill || "",
      subscriptionAccountNumber: this.props.billing?.customerAccount?.accountNumberSubscription || "",
      smsAccountNumber: this.props.billing?.customerAccount?.accountNumberSms || "",
      monthlySubscriptionCost: this.props.billing?.customerAccount?.monthlySubscriptionCost || 0,
      annualSubscriptionCost: this.props.billing?.customerAccount?.annualSubscriptionCost || 0,
      quarterlySubscriptionCost: this.props.billing?.customerAccount?.quarterlySubscriptionCost || 0,
      annualDiscountPercentage: this.props.billing?.customerAccount?.annualDiscountPercentage || 0,
      quarterlyDiscountPercentage: this.props.billing?.customerAccount?.quarterlyDiscountPercentage || 0,
    };

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle style={{ textAlign: "center" }}>Subscription Expired</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid className="ion-padding">
            <IonRow>
              <IonCol>
                <IonText>
                  <h1 style={{ fontSize: "2rem", color: "black", textAlign: "center" }}>
                    Subscription Expired!
                  </h1>
                </IonText>
              </IonCol>
            </IonRow>

            <IonRow className="ion-margin-top ion-margin-bottom">
              <IonText>
                <h3 style={{ fontSize: "1.5rem" }}>
                  Your Current Subscription Balance: <b>{subscriptionBalance} Kshs</b>
                </h3>
              </IonText>
            </IonRow>

            {this.state.currentStep === 1 && (
              <>
                <IonRow className="ion-margin-top">
                  <IonCol>
                    <SubscriptionPlans
                      subscriptionPeriod={this.state.subscriptionPeriod}
                      setSubscriptionPeriod={this.handleSubscriptionPeriodChange}
                      annualPrice={paybillDetails.annualSubscriptionCost}
                      quarterlyPrice={paybillDetails.quarterlySubscriptionCost}
                      monthlyPrice={paybillDetails.monthlySubscriptionCost}
                      annualDiscountPercentage={paybillDetails.annualDiscountPercentage}
                      quarterlyDiscountPercentage={paybillDetails.quarterlyDiscountPercentage}
                    />
                  </IonCol>
                </IonRow>

                <IonRow className="ion-margin-top ion-justify-content-center">
                  <IonCol size="10">
                    <IonButton
                      expand="block"
                      onClick={this.nextStep}
                      style={{
                        backgroundColor: colorTheme.primary[700],
                        borderRadius: "10px",
                      }}
                    >
                      Next
                    </IonButton>
                  </IonCol>
                </IonRow>
              </>
            )}

            {this.state.currentStep === 2 && (
              <>
                <IonText className="ion-text-center ion-margin-bottom ion-margin-top">
                  Choose payment method
                </IonText>
                {Object.values(PAYMENT_METHODS).map((method) => (
                  <div className="form-check my-3 ml-5" key={method}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentMethod"
                      id={`paymentMethod-${method}`}
                      value={method}
                      checked={this.state.paymentMethod === method}
                      onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                    />
                    <label className="form-check-label" htmlFor={`paymentMethod-${method}`}>
                      {method}
                    </label>
                  </div>
                ))}

                <IonRow className="ion-margin-top">
                  <IonCol>
                    {this.state.paymentMethod === PAYMENT_METHODS.MPESA && (
                      <MpesaPayment
                        amount={subscriptionBalance}
                        phoneNumber={this.state.phoneNumber}
                        phoneNumberFormatted={this.state.phoneNumberFormatted}
                        onPhoneNumberChange={(value, formatted) => {
                          this.setState({
                            phoneNumber: value,
                            phoneNumberFormatted: formatted,
                          });
                        }}
                        onPhoneNumberValidation={(value) => {
                          const error = value ? "" : "Phone number is required";
                          this.setState(prev => ({
                            errors: { ...prev.errors, phoneNumber: error }
                          }));
                        }}
                        onStkPush={this.handleStkPush}
                        errors={this.state.errors}
                      />
                    )}
                    {this.state.paymentMethod === PAYMENT_METHODS.CREDIT_CARD && (
                      <CreditCardPayment
                        amount={subscriptionBalance}
                        onCreditCardPayment={this.handleCreditCardPayment}
                        onCancelSubscription={this.handleCancelSubscription}
                      />
                    )}
                    {this.state.paymentMethod === PAYMENT_METHODS.PAYBILL && (
                      <PaybillPayment
                        amount={subscriptionBalance}
                        paybillDetails={paybillDetails}
                        selectedPlan="SUB"
                      />
                    )}
                  </IonCol>
                </IonRow>

                <IonRow className="ion-margin-top ion-justify-content-center">
                  <IonCol size="10">
                    <IonButton
                      expand="block"
                      fill="outline"
                      onClick={this.prevStep}
                      style={{
                        borderColor: colorTheme.primary[700],
                        borderRadius: "10px",
                      }}
                    >
                      Previous
                    </IonButton>
                  </IonCol>
                </IonRow>
              </>
            )}

            <IonRow className="ion-margin-top ion-justify-content-center">
              <IonCol className="ion-text-center" size="10">
                <IonButton
                  expand="block"
                  color="success"
                  onClick={this.handleIHavePaid}
                  style={{
                    backgroundColor: colorTheme.primary[700],
                    borderRadius: "10px",
                  }}
                >
                  I have Paid!
                </IonButton>
              </IonCol>
            </IonRow>

            <IonRow className="ion-margin-top">
              <IonCol>
                <IonText color="medium" className="ion-text-center">
                  <p>
                    If you have already paid and can't access the app, please contact customer support:
                    <br />
                    Email: newton@bomahut.com
                    <br />
                    Phone: +254 717 512 483
                  </p>
                </IonText>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubscriptionExpired));
